import React, { Component } from "react";
import styled from "styled-components";
import Select from '../dev/Select';
import { Consumer } from "../context/InfoContext";
import Row from "../dev/Row";
import Span from "../dev/Span";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    ComposedChart,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar,
    Line
} from "recharts";
import {fakeGraphData} from './dev/fakeGraphData'
/*這邊 Code 全部都是廢物 PM 寫的喔 小心*/

class Graph extends Component {
    state = {
        info: {},
        infoId: -1,
        graphType:
            "觀看數" /*選擇哪個數據的圖表 訂閱數/觀看數/訂閱數成長率/平均互動率/日觀看成長率*/,
        barName: "todayViewCount",
        lineName: "totalViewCount",
        monthCount: 1,
    };
    componentDidMount() {
        const { infoId } = this.props.match.params;
        const { graphType, monthCount } = this.state;
        const { REACT_APP_URI = "/" } = process.env;
        fetch(
            `${REACT_APP_URI}/ChannelMonthlyData/${infoId}?category=${graphType}&${monthCount}`,
            { credentials: "include" }
        ).then(res => {
            if (res.ok) return res.json();
            else throw res;
        })
        .then(Info => this.setState({ info: Info}))
    }
    fectchData() {
        const { infoId } = this.props.match.params;
        const { REACT_APP_URI = "/" } = process.env;
        const { graphType, monthCount } = this.state
        console.log({monthCount});
        fetch(
            `${REACT_APP_URI}/ChannelMonthlyData/${infoId}?category=${graphType}&monthCount=${monthCount}`,
            { credentials: "include" }
        )
        .then(res => {
            if (res.ok) return res.json();
            else throw res;
        })
        .then(Info => this.setState({ info: Info }));
    }
    monthSelect = ({ value = "", label = "" }) => this.setState({ monthCount: value },() => this.fectchData());
    
    formatter = value => `${value}%`;

    checkminus(info) {
        var isMinus = false;
        for (var i = 0; i < info.length; i++) {
            if (parseInt(info[i].barData, 10) < 0) {
                isMinus = true;
            }
        }
        return isMinus;
    }
    /*changeNumberToMilionAndKilo = (e) => {
            if (Math.abs(e) >= 1000000000) {
            return (e / 1000000000).toFixed(1) + 'B'
            }
            if (Math.abs(e) >= 1000000) {
                return (e / 1000000).toFixed(1) + 'M'
            }
            if(Math.abs(e) >=1000) {
                return (e / 1000).toFixed(1)+'K'
            }
            return e
        
    }原本已經轉換好了 但發現如果基數太小 刻度會全部變一樣 還是先算了吧= =*/
    render() {
        const { messages } = this.props;
        return (
            <Consumer>
                {value => {
                    const monthOptions = [
                        {
                            value: 1,
                            label: messages.last_one_month,
                            clearablevalue: false
                        },
                        {
                            value: 2,
                            label: messages.last_two_month,
                            clearablevalue: false
                        },
                        {
                            value: 3,
                            label: messages.last_three_month,
                            clearablevalue: false
                        },
                        {
                            value: 4,
                            label: messages.last_four_month,
                            clearablevalue: false
                        },
                        {
                            value: 5,
                            label: messages.last_five_month,
                            clearablevalue: false
                        },
                        {
                            value: 6,
                            label: messages.last_six_month,
                            clearablevalue: false
                        },
                    ]
                    const { monthSelect } = this
                    const { info, graphType, barName, lineName, monthCount } = this.state;
                    const { user:{plan, auth} } = this.props
                    const data = (auth === 'notSignIn' || plan === 'Free' || plan === 'Creator') ? fakeGraphData : info
                    return (
                        <GraphDefault id="user_tour_info_6">
                            <Row item="center" content="space-between" padding="24px" borderbottom>
                                <Span spanTitle>{messages.info_graphics}</Span>
                                <StyledSelect
                                    value={monthCount}
                                    onChange={monthSelect}
                                    options={monthOptions}
                                    placeholder={monthOptions.find(i => i.value === monthCount).label}
                                    id='Country'
                                />
                            </Row>
                            <CategoryField>
                                <Category
                                    content="觀看數"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "觀看數",
                                            barName: "todayViewCount",
                                            lineName: "totalViewCount"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.info_total_views}
                                </Category>
                                <Category
                                    content="近20支平均觀看數"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "近20支平均觀看數",
                                            barName: "recentAvgViewCount",
                                            lineName: "recentAvgViewCount"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.recentAvgViewCount}
                                </Category>
                                <Category
                                    content="近兩個月平均觀看數"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "近兩個月平均觀看數",
                                            barName: "twoMonthAvgViewCount",
                                            lineName: "twoMonthAvgViewCount"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.twoMonthAvgViewCount}
                                </Category>
                                <Category
                                    content="訂閱數"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "訂閱數",
                                            barName:
                                                "todaySubscriberCount",
                                            lineName: "subscriberCount"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.subscriberCount}
                                </Category>
                                <Category
                                    content="訂閱數成長率"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "訂閱數成長率",
                                            lineName:
                                                "todaySubscriberRate"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.todaySubscriberRate}
                                </Category>
                                <Category
                                    content="日觀看成長率"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "日觀看成長率",
                                            lineName: "todayViewRate"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.todayViewRate}
                                </Category>
                                <Category
                                    content="平均互動率"
                                    nowstate={this.state.graphType}
                                    onClick={() => {
                                        this.setState({
                                            graphType: "平均互動率",
                                            lineName: "avgEngageRate"
                                        },() => this.fectchData());
                                    }}
                                >
                                    {messages.avgEngageRate}
                                </Category>
                            </CategoryField>
                            {Object.keys(data).length !== 0 &&
                                this.checkminus(data) &&
                                graphType === "觀看數" && (
                                    <Alert>
                                        {messages.info_graphics_view_minus}
                                    </Alert>
                                )}
                            <Mask isBlur={value.isBlur} noCircle={monthCount !==  1}>
                                <ComposedChart
                                    width={860}
                                    height={250}
                                    data={data}
                                    margin={{
                                        top: 8,
                                        right: 36,
                                        bottom: 24,
                                        left: 36
                                    }}
                                    barSize={14}
                                    barGap={4}
                                >
                                    <XAxis dataKey="date" />
                                    <YAxis
                                        domain={["auto", "auto"]}
                                        /*tickFormatter={this.changeNumberToMilionAndKilo*/ tick={{
                                            fill: "rgba(222, 6, 6, 0.5)"
                                        }}
                                        yAxisId="right"
                                        orientation="right"
                                    />
                                    <YAxis
                                        domain={["auto", "auto"]}
                                        tickFormatter={
                                            graphType === "訂閱數成長率" ||
                                            graphType === "日觀看成長率" ||
                                            graphType === "平均互動率"
                                                ? this.formatter
                                                : "" /*this.changeNumberToMilionAndKilo*/
                                        }
                                        yAxisId="left"
                                        orientation="left"
                                    />
                                    <Tooltip
                                        formatter={
                                            graphType === "訂閱數成長率" ||
                                            graphType === "日觀看成長率" ||
                                            graphType === "平均互動率"
                                                ? this.formatter
                                                : ""
                                        }
                                    />
                                    <Legend />
                                    {(graphType === "訂閱數" ||
                                        graphType === "觀看數") && (
                                        <Bar
                                            name={messages[barName]}
                                            yAxisId="right"
                                            dataKey="barData"
                                            fill="rgba(222, 6, 6, 0.5)"
                                        />
                                    )}
                                    <Line
                                        name={messages[lineName]}
                                        yAxisId="left"
                                        type="monotone"
                                        dataKey="lineData"
                                        stroke="rgba(0, 0, 0, 0.5)"
                                    />
                                </ComposedChart>
                            </Mask>
                        </GraphDefault>
                    );
                }}
            </Consumer>
        );
    }
}

const mapStateToProps = state => {
    return {
        messages: state.Messages,
        user: state.User
    };
};
export default withRouter(connect(mapStateToProps)(Graph));
//export default Rank;

const GraphDefault = styled.div`
    grid-area: graph;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: auto;
`;
const Category = styled.div`
    display: inline-flex;
    word-break: break-all;
    height: 24px;
    padding: 0 8px;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 24px;
    border: ${props =>
        props.content === props.nowstate
            ? "solid 0.5px transparent"
            : "solid 0.5px #979797"};
    background-color: ${props =>
        props.content === props.nowstate ? "rgba(222, 6, 6, 0.5)" : "#fff"};
    font-size: 14px;
    font-weight: 300;
    color: ${props => (props.content === props.nowstate ? "#fff" : "#979797")};
    cursor: pointer;
`;

const Alert = styled.div`
    margin-bottom: 24px;
    margin-left: 24px;
    color: rgba(222, 6, 6, 0.5);
`;
const Mask = styled.div`
    ${({ isBlur }) => isBlur ? 'filter: blur(5px)' : ''};
    circle {
        ${({ noCircle }) => noCircle ? "display: none" : ""};
    }
`
const CategoryField = styled.div`
    padding: 24px 0 24px 20px;
`
const StyledSelect = styled(Select)`
    z-index: 5001;
    @media (max-width: 900px) {
        width: 100%;
    }
`


// WEBPACK FOOTER //
// ./src/Info/Graph.js